module.exports = __webpack_public_path__ + "img/arrow_left_3.f92cd1ec.svg";